import { setupMobX } from '../util/setupMobX';
import { observable, makeObservable, action, runInAction } from 'mobx';
import { showErrorNotification } from '../component/notification';
import { handleRequestError } from '../request';
import {
  getMyCurrentThc,
  getCurrentThcLimit,
} from '../request/authenticated-requests/participant-thc';

export class ConsumptionStore {
  @observable public loadingCurrentLimit: boolean = false;
  @observable public currentLimit: number = 0;
  @observable public currentThcAmount: number = 0;
  @observable public currentThcUnit: string = 'g';

  constructor() {
    makeObservable(this);
  }

  @action public getCurrentThcAmount = () => {
    getMyCurrentThc()
      .then((response) => {
        runInAction(() => {
          this.currentThcAmount = response.thcConsumptionThisMonth;
          this.currentThcUnit = response.unit;
        });
      })
      .catch((error) => handleRequestError(error));
  };

  @action public getCurrentLimit = () => {
    this.loadingCurrentLimit = true;

    getCurrentThcLimit()
      .then((res) => runInAction(() => (this.currentLimit = res.thcLimit)))
      .catch(() => showErrorNotification())
      .finally(() => runInAction(() => (this.loadingCurrentLimit = false)));
  };
}

const { provider, useStore } = setupMobX<ConsumptionStore>();
export const useConsumptionStore = useStore;
export const ConsumptionStoreProvider = provider;
